module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-19.5db70355.jpg";